import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { infoSelector } from 'selectors/indicator';

// Components
import TextBlock from 'components/textBlock';

// Styles
import styles from './endnote.scss';

/**
 * Section that describes the notes and sources for each indicator.
 * @param  {string} options.notes   Notes regarding indicator
 * @param  {string} options.sources Source information
 * @return {object}                 Component jsx
 */
const Endnote = ({ info: { notes = '', sources = '', definitions = '' } }) => {
  if (!notes && !sources) {
    return '';
  }

  return (
    <section className={styles.endnote}>
      <h2 className={styles.title}>
        Endnotes
      </h2>
      {notes &&
        <TextBlock
          title="Notes"
          text={notes}
        />
      }
      {sources &&
        <TextBlock
          title="Sources"
          text={sources}
        />
      }
      {definitions &&
        <TextBlock
          title="Definitions"
          text={definitions}
        />
      }
    </section>
  );
};

Endnote.propTypes = {
  info: PropTypes.shape({
    notes: PropTypes.string,
    sources: PropTypes.string,
    definitions: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  info: infoSelector(state),
});

export default connect(mapStateToProps)(Endnote);



// WEBPACK FOOTER //
// ./app/components/endnote/index.js